import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from '../../../utils/redux-injectors';
import { AdminNotification } from '../../../types';
import { adminNotificationsSaga } from './saga';
import { AdminNotificationsState } from './types';

const initialState: AdminNotificationsState = {
  items: [],
  unreadCount: 0,
  listLoading: false,
  error: null,
};

const adminNotificationsSlice = createSlice({
  name: 'adminNotifications',
  initialState,
  reducers: {
    fetchListRequest(
      state,
      _action: PayloadAction<{ limit?: number; unreadOnly?: boolean } | undefined>,
    ) {
      state.listLoading = true;
      state.error = null;
    },
    fetchListSuccess(state, action: PayloadAction<AdminNotification[]>) {
      state.listLoading = false;
      state.items = action.payload;
    },
    fetchListFailure(state) {
      state.listLoading = false;
      state.error = 'Failed to load notifications';
    },
    fetchUnreadCountSuccess(state, action: PayloadAction<number>) {
      state.unreadCount = action.payload;
    },
    markReadRequest(_state, _action: PayloadAction<string>) {},
    markReadSuccess(state, action: PayloadAction<AdminNotification>) {
      const idx = state.items.findIndex((n) => n.id === action.payload.id);
      if (idx >= 0) {
        state.items[idx] = action.payload;
      }
      if (!action.payload.read) return;
      if (state.unreadCount > 0) state.unreadCount -= 1;
    },
    markAllReadRequest() {},
    markAllReadSuccess(state) {
      state.items = state.items.map((n) => ({ ...n, read: true }));
      state.unreadCount = 0;
    },
    deleteRequest(_state, _action: PayloadAction<string>) {},
    deleteSuccess(state, action: PayloadAction<string>) {
      const removed = state.items.find((n) => n.id === action.payload);
      state.items = state.items.filter((n) => n.id !== action.payload);
      if (removed && !removed.read && state.unreadCount > 0) {
        state.unreadCount -= 1;
      }
    },
    pollRequest() {},
  },
});

export const adminNotificationsActions = adminNotificationsSlice.actions;
export const adminNotificationsReducer = adminNotificationsSlice.reducer;
export const initialAdminNotificationsState = initialState;

export function useAdminNotificationsSlice() {
  useInjectReducer({ key: 'adminNotifications', reducer: adminNotificationsSlice.reducer });
  useInjectSaga({ key: 'adminNotifications', saga: adminNotificationsSaga });
  return { actions: adminNotificationsSlice.actions };
}
